import { TagDescription } from '@reduxjs/toolkit/query';
import map from 'lodash/map';

export type IdentifiableObject = { id: string | number };

export const provideTags = <
    TagName extends string,
    Objects extends IdentifiableObject[],
>(
    name: TagName,
    objects?: Objects
): TagDescription<TagName>[] => {
    return [
        { type: name, id: 'LIST' },
        ...map(objects, (o: IdentifiableObject) => ({ type: name, id: o.id })),
    ];
};
